module.exports = "/static/assets/ba9e5a0436dd99d7549c4f75bbcded29.svg";